import React, { Component } from 'react';
import DateFormat from '../../lib/date/DateFormat';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import {connect} from "react-redux";

class CallItem extends Component {
    render() {
        const {call, key, translate} = this.props;
        let normalizeDescription = (description) => {
            return description
                .replace("call_in", translate('call_in'))
                .replace("sms_in", translate('sms_in'))
                .replace("call_roaming", translate('call_roaming'))
                .replace("_to_", translate('_to_'))
                .replace(/^[\s_]+|[\s_]+$/g, '')
                .replace(/[_\s]+/g, ' ')
                .replace(/^[a-z]/, function (m) {
                    return m.toUpperCase();
                })
                ;
        }
        return (
            <tr key={key}>
                <td>
                    <DateFormat date={call.call_date}/>
                </td>
                <td>
                    {call.call_hour}
                </td>
                <td>
                    {call.src}
                </td>
                <td>
                    {call.dialled_number}
                </td>
                <td>
                    {call.call_duration}
                </td>
                <td>
                    {call.user_price}
                </td>
                <td>
                    {normalizeDescription(call.description)}
                </td>
                <td>
                </td>
            </tr>
        )
    }
}

const viewMapStateToProps = (state) => {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
    }
}

const viewMapDispatchToProps = (dispatch) => {
    return {
        dispatch
    }
}

CallItem = connect(
    viewMapStateToProps,
    viewMapDispatchToProps
)(CallItem);

export default CallItem;



// WEBPACK FOOTER //
// ./src/components/CallDetails/CallItem.js